import script from "./HeartIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeartIcon.vue?vue&type=script&setup=true&lang=ts"

import "./HeartIcon.vue?vue&type=style&index=0&id=0ffe425d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffe425d"]])

export default __exports__